const initialState = {
    pending: false,
    communitySensors: [],
    page: 0,
    itemsCount: 0,
    pageCount: 0,
    error: null,
    filters: {active: 'ALL', itemsPerPage: 3, search: ''},
    selected: {}
};

const communitySensorsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_COMMUNITY_SENSORS_PENDING':
            return {
                ...state,
                pending: true
            };
        case 'GET_COMMUNITY_SENSORS_SUCCESS':
            return {
                ...state,
                pending: false,
                communitySensors: action.sensors,
                page: action.page,
                pageCount: action.pageCount,
                itemsCount: action.itemsCount
            };
        case 'GET_COMMUNITY_SENSORS_ERROR':
            return {
                ...state,
                pending: false,
                error: action.error
            };
        case 'SELECT_COMMUNITY_SENSOR':
            return {
                ...state,
                selected: action.selected
            };
        case 'SET_COMMUNITY_SENSORS_FILTERS':
            return {
                ...state,
                filters: action.filters
            };
        case 'ADD_COMMUNITY_SENSOR_SUCCESS':
            return {
                ...state,
                pending: false
            };
        case 'ADD_COMMUNITY_SENSOR_ERROR':
            return {
                ...state,
                pending: false,
                error: action.error
            };
        default:
            return state;
    }
};

export default communitySensorsReducer;
